import MediaRecorder from './MediaRecorder';

export default MediaRecorder;
